<template>
  <div class="black-card">
    <a
      class="black-card__top"
      target="_blank"
      :href="`${$baseUrl}documents/${content.pdfLink}.pdf`"
      @click="
        digitalData({
          event: content.event,
          eventDetail: content.eventDetail,
          contentTitle: content.title,
          contentUrl: content.pdfLink,
          ctaLabel: content.title,
        })
      "
    >
      <div class="black-card__top__wrapper">
        <div>
          <p class="black-card__top__wrapper__title">{{ content.title }}</p>
          <p class="black-card__top__wrapper__subtitle">
            {{ content.subtitle }}
          </p>
        </div>
        <div>
          <icon
            :data="pageIcons[content.icon]"
            class="black-card__top__wrapper__icon"
          ></icon>
          <span
            class="black-card__top__wrapper__text"
            v-if="tvaMq === 'desktop'"
            >{{ content.hiddenText }}</span
          >
        </div>
      </div>
      <div class="black-card__top__image">
        <img :src="`${$baseUrl}images/${content.image}.png`" alt="" />
      </div>
    </a>
    <div class="black-card__bottom">
      <span class="black-card__bottom__pre">{{ content.cta.pre }}</span>
      <!-- For now no link here, later yes? -->
      <a
        class="black-card__bottom__wrapper"
        :href="content.cta.link"
        target="_blank"
        @click="
          digitalData({
            event: content.cta.event,
            eventDetail: content.cta.eventDetail,
            contentTitle: content.cta.label,
            contentUrl: content.cta.link,
            ctaLabel: content.cta.label,
          })
        "
        v-if="content.cta.link.length !== 0"
      >
        <span class="black-card__bottom__wrapper__label">{{
          content.cta.labelForAquista
        }}</span>
        <icon
          :data="pageIcons[content.cta.icon]"
          class="black-card__bottom__wrapper__icon"
        ></icon>
      </a>
      <span class="black-card__bottom__wrapper__label" v-else>{{
        content.cta.label
      }}</span>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { pageIcons } from "../../../plugins/page-icons";
import { useGoogleAnalytics } from "../../../plugins/useGoogleAnalitycs";

const { digitalData } = useGoogleAnalytics();

defineProps({ content: Object });

const tvaMq = inject("$tvaMq");
</script>

<style lang="scss" scoped>
.black-card {
  &__top {
    display: flex;
    color: $scala-grigi-white;
    text-align: left;
    background-color: $scala-grigi-gray_1;
    overflow: hidden;
    @include shadow-cards;

    &__wrapper {
      padding: toRem(10) toRem(10) toRem(20) toRem(10);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      pointer-events: none;

      &__title {
        @include title-h-2;
      }

      &__subtitle {
        margin-top: toRem(10);
        @include title-h-5;
      }

      &__icon {
        min-width: 1.5rem;
        min-height: 1.5rem;

        :deep(path) {
          transition: all 0.3s ease;
          fill: $scala-grigi-white;

          &:last-child {
            stroke: $scala-grigi-white;
          }
        }
      }

      &__text {
        margin-left: toRem(18);
        transition: opacity 0.3s ease;
        opacity: 0;
        @include link-m;
      }
    }

    &__image {
      width: 100%;
      overflow: hidden;
      & > img {
        transition: transform 0.3s ease;
        width: 100%;
        height: 100%;
      }
    }

    &:hover {
      .black-card__top__wrapper {
        &__icon {
          :deep(path) {
            fill: $primary-yellow;

            &:last-child {
              stroke: $primary-yellow;
            }
          }
        }

        &__text {
          opacity: 1;
        }
      }

      .black-card__top__image {
        & > img {
          transform: scale(1.07);
        }
      }
    }
  }

  &__bottom {
    margin-top: toRem(25);
    display: flex;
    justify-content: center;

    &__pre {
      @include p-m;
    }

    &__wrapper {
      display: flex;
      align-items: flex-end;

      &__label {
        margin-left: toRem(11);
        position: relative;
        text-align: left;

        @include link-l;

        &::before {
          content: "";
          height: 1px;
          width: 100%;
          position: absolute;
          bottom: 0;
          transition: opacity 0.3s ease;
          opacity: 0;
          background-color: $primary-yellow;
        }
      }

      &__icon {
        min-height: 1.313rem;
        min-width: 1.313rem;
        margin-left: toRem(6.5);
        transition: color 0.3s ease;
      }

      &:hover {
        .black-card__bottom__wrapper__label {
          &::before {
            opacity: 1;
          }
        }

        .black-card__bottom__wrapper__icon {
          color: $primary-yellow;
        }
      }
    }
  }
}

.tablet,
.mobile {
  .black-card {
    &__top {
      &__wrapper {
        padding: toRem(10) toRem(80) toRem(20) toRem(10);

        &__title {
          @include title-h-3;
          font-size: 1.75rem;
        }

        &__subtitle {
          @include tasselli-titolo-s;
        }
      }

      &__image {
        width: 80%;
      }
    }

    &__bottom {
      margin-top: toRem(16);

      &__wrapper {
        &:hover {
          .black-card__bottom__wrapper__label {
            &::before {
              opacity: 0;
            }
          }

          .black-card__bottom__wrapper__icon {
            color: inherit;
          }
        }
      }
    }
  }
}

.mobile {
  .black-card {
    &__top {
      &__wrapper {
        padding: toRem(10) toRem(20) toRem(20) toRem(10);
      }
    }
  }
}
</style>
